import { Translate } from "@redotech/redo-i18n";
import { PriceOption } from "@redotech/redo-return-core-common/condition-options";

/** Display label for a price comparison option; the stored enum value stays English. */
export function getPriceOptionLabel(
  option: PriceOption,
  translate: Translate,
): string {
  const t = translate;
  switch (option) {
    case PriceOption.LESS_THAN:
      return t("Less than");
    case PriceOption.GREATER_THAN:
      return t("Greater than");
    case PriceOption.CENTS_EQUALS:
      return t("Cents equals");
    case PriceOption.EQUALS:
      return t("Equals");
  }
}
